import React from "react";
import { TextInputProps, TextInput } from "../../inputs/TextInput";
import { FormField, formFieldValidationHelper } from "../FormField";
import { iconName } from "../../icons/Icons";

type TextFieldProps = Omit<TextInputProps, 'inErrorState' | 'onChange'> & {
    label?:string,
    hideLabel?:boolean,
    infoMessage?:string,
    errorMessage?:string,
    reserveMessageSpace?:boolean,
    leadingIcon?:iconName,
    trailingIcon?:iconName,
    validator?:(value:string) => { valid:true } | {valid:false, errorMessage:string},
    onChange?:(value:string, isValid:boolean)=>void
};

export function TextField(props:TextFieldProps)
{
    const validation = formFieldValidationHelper(props.value, props.infoMessage, props.errorMessage, props.validator);

    function handleChange(value:string)
    {
        props.onChange?.(value, !validation.inErrorState);
    }

    return (

        <FormField 
            reserveMessageSpace={props.reserveMessageSpace}
            hideLabel={props.hideLabel}
            label={props.label || ''} 
            inputComponent={
                <TextInput {...props} inErrorState={validation.inErrorState} onChange={handleChange} leadingIcon={props.leadingIcon} trailingIcon={props.trailingIcon} />
            }
            inErrorState={validation.inErrorState}
            message={validation.message}
        />
    )
}                            